import React, { memo } from "react";
import styled from "styled-components";
import PlayIcon from "../../../../../common/assets/icons/play_icon";
import AdminPageInfoIcon from "../../../../../common/assets/icons/admin_page_icons/admin_page_info_icon";

const GroupPreviewContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  height: 95px;
  max-width: 630px;
  margin-left: 64px;
  padding: 12px;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  opacity: ${({ unselected }) => (unselected ? "0.5" : "1")};
  transition: 0.2s;

  &:hover {
    box-shadow: 4.732px 4.732px 8.281px 0px rgba(0, 0, 0, 0.12);
  }
`;

const GroupImageContainer = styled.div`
  border-radius: 8px;
  min-width: 119px;
  max-width: 119px;
  height: 100%;
  background: rgb(195 194 248);
  overflow: hidden;
`;

const GroupImage = styled.img`
  width: 100%;
  height: 100%;
`;

const GroupStatus = styled.div`
  position: absolute;
  top: 9px;
  left: 9px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: ${({ color }) => color};
`;

const GroupInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: 2px 0;
`;

const GroupTitle = styled.div`
  color: #1e1e1e;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const GroupAuthor = styled.div`
  color: #828282;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  padding-bottom: 2px;
`;

const GroupDateAndSeatsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const GroupDate = styled.div`
  color: #cacaca;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.4px;

  span {
    color: #f8d254;
    font-weight: 600;
  }
`;

const GroupSeats = styled(GroupDate)``;

const GroupButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  height: fit-content;
  width: max-content;
`;

const GroupButton = styled.div`
  cursor: pointer;

  svg {
    transition: 0.2s;
  }

  &:hover {
    svg {
      transform: scale(1.14);
    }
  }
`;

const PlayIconStyles = styled(PlayIcon)`
  width: 100%;
  height: 18px;
  padding-left: 2px;
`;

const GroupPreview = ({ groupInfo = {} }) => {
  const groupStatusColor =
    groupInfo.group_status === "open" ? "#3819FF" : "#A1A1A1";
  const previewImage =
    "https://api.on-bible.com/uploads/ee1e3bb55d2a134c7dc6.jpg";
  const groupTitle = "Суббота или воскресенье";
  const groupAuthor = "Феликс Понятовский";
  const startDate = "10.11.2025";
  const endDate = "10.11.2025";
  const seatsAmount = "100";

  return (
    <GroupPreviewContainer unselected={false}>
      <GroupStatus color={groupStatusColor} />

      <GroupImageContainer>
        {previewImage && <GroupImage src={previewImage} alt="Group Image" />}
      </GroupImageContainer>

      <GroupInfoContainer>
        <GroupTitle>{groupTitle}</GroupTitle>
        <GroupAuthor>{groupAuthor}</GroupAuthor>
        <GroupDateAndSeatsContainer>
          <GroupDate>
            Даты{" "}
            <span>
              {startDate || ""} - {endDate || ""}
            </span>
          </GroupDate>
          <GroupSeats>
            Места <span>{seatsAmount || "-"}</span>
          </GroupSeats>
        </GroupDateAndSeatsContainer>
      </GroupInfoContainer>

      <GroupButtonsContainer>
        <GroupButton onClick={() => {}}>
          <AdminPageInfoIcon />
        </GroupButton>
        <GroupButton onClick={() => {}}>
          <PlayIconStyles color={"#F8D254"} />
        </GroupButton>
      </GroupButtonsContainer>
    </GroupPreviewContainer>
  );
};

export default memo(GroupPreview);
